import React, { useEffect } from 'react'
import { IntroductionContent, LinkModalContent } from '../components/Content/HomeScreen'
import CategoriesTable from '../components/Table/CategoriesTable'

const ScrollToTopOnMount = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return null
}

const HomeScreen = ({ ...other }) => {
  return (
    <>
      <ScrollToTopOnMount />
      <div id="main">
        <div className="container home">
          <IntroductionContent />
          <LinkModalContent />
          <CategoriesTable/>
        </div>
      </div>
    </>
  )
}

export default HomeScreen
